function readRuntimeEnv(name: 'VITE_API_URL' | 'VITE_GAME_URL', defaultValue: string): string {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.length > 0 ? value : defaultValue;
}

function normalizeBaseUrl(baseUrl: URL): URL {
  const normalized = new URL(baseUrl.href);

  if (!normalized.pathname.endsWith('/')) {
    normalized.pathname = `${normalized.pathname}/`;
  }

  return normalized;
}

function buildHttpUrl(baseUrl: URL, pathname: string): URL {
  return new URL(pathname, normalizeBaseUrl(baseUrl));
}

class RuntimeUrls {
  public readonly apiUrl: URL;

  public readonly gameUrl: URL;

  constructor() {
    this.apiUrl = new URL(readRuntimeEnv('VITE_API_URL', 'http://localhost:3000'));
    this.gameUrl = new URL(readRuntimeEnv('VITE_GAME_URL', 'http://localhost:8080'));
  }

  public getAuthUrl(path: string): string {
    return buildHttpUrl(this.apiUrl, `auth/${path}`).href;
  }

  public getGameJoinUrl(gameId: string): string {
    return buildHttpUrl(this.gameUrl, `game/${encodeURIComponent(gameId)}`).href;
  }
}

export const runtimeUrls = new RuntimeUrls();
